import { Skeleton } from "@nextui-org/react";

export function TableSkeleton() {
  return (
    <div className="flex-1 overflow-auto">
      {/* Table Header Skeleton */}
      <div className="flex items-center px-6 py-3 border-b border-[#E4E4E7] bg-[#F9FAFB]">
        <Skeleton className="h-4 w-32 rounded" />
        <div className="flex-1" />
        <Skeleton className="h-4 w-16 rounded mx-4" />
        <Skeleton className="h-4 w-24 rounded mx-4" />
        <Skeleton className="h-4 w-20 rounded" />
      </div>

      {/* Vendor Row Skeletons */}
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="border-b border-[#E4E4E7]">
          {/* Vendor Row */}
          <div className="flex items-center px-6 py-4 bg-[#F9FAFB]">
            <Skeleton className="h-4 w-4 rounded mr-3" /> {/* Chevron */}
            <Skeleton className="h-8 w-8 rounded-full mr-3" /> {/* Logo */}
            <div className="flex flex-col gap-1 flex-1">
              <Skeleton className="h-4 w-40 rounded" /> {/* Vendor name */}
              <Skeleton className="h-3 w-24 rounded" /> {/* Assessment count */}
            </div>
            <Skeleton className="h-6 w-16 rounded mx-4" /> {/* Risk badge */}
            <Skeleton className="h-4 w-24 rounded mx-4" /> {/* Date */}
            <Skeleton className="h-4 w-28 rounded" /> {/* Status */}
          </div>

          {/* Product Row Skeletons (expanded) */}
          {[1, 2].map((j) => (
            <div key={j} className="flex items-center px-6 py-3 pl-16 bg-white">
              <Skeleton className="h-4 w-32 rounded flex-1" /> {/* Product name */}
              <Skeleton className="h-6 w-16 rounded mx-4" /> {/* Risk */}
              <Skeleton className="h-4 w-24 rounded mx-4" /> {/* Date */}
              <Skeleton className="h-4 w-24 rounded mr-4" /> {/* Status */}
              <Skeleton className="h-6 w-6 rounded" /> {/* Actions */}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
